
<div class="row text-center" [ngClass]="{'ma-phone-otp ma-font-setup': !isAcmic}">
  <div class="col" *ngIf="codeExpired; else enterCode">
    <div class="header-icon margin-bottom mb8">
      <figure>
        <img src="./assets/img/images/expired.svg" alt="Otp" />
      </figure>
    </div>
    <h1 class="title-copy">{{ "CODE_EXPIRED_OR_INVALID" | translate }}</h1>
    <p>{{ "SEND_NEW_CODE" | translate }}</p>
    <p class="ma-contact-info">{{ phoneNum }}</p>
    <div class="row group-button text-center">
      <div class="col">
        <mapfre-button
          [additionalClasses]="'basic primary large-btn'"
          [disabledValue]="phoneOtpForm.valid"
          [translateValue]="'SEND NEW CODE' | translate"
          (click)="sendNewCode()"
        >
          {{ "SEND_NEW_CODE_CAPITAL_CASE" | translate }}
        </mapfre-button>
      </div>
    </div>
    <p class="mt-3 mb-0">
      {{ "OR_CONTACT_OUR_CUSTOMER_SERVICE" | translate }}
    </p>
    <p>
        <a href="tel:{{ 'CUSTOMER_SERVICE_NUMBER' | translate }}" class="mapfre link blue-link " [ngClass]="{ 'corporate-red dm-sans-medium font-weight-500': !isAcmic , 'underline': isAcmic}">
            {{ "CUSTOMER_SERVICE_NUMBER" | translate }}
        </a>
      </p>
  </div>
  <ng-template #enterCode>
    <div class="col">
      <div class="header-icon margin-bottom mb8">
        <figure>
          <img src="./assets/img/images/otp.svg" alt="Otp" />
        </figure>
      </div>
      <h1 class="title-copy">{{ "ENTER_CODE" | translate }}</h1>
      <p>
        {{ "SECURITY_CODE_MOBILE_PHONE" | translate }}
      </p>
      <p class="ma-contact-info">{{ phoneNum }}</p>
      <form
        [formGroup]="phoneOtpForm"
        name="phoneOtpForm"
        (ngSubmit)="phoneOtpForm.valid && verfiyOtp()"
        class="s-signUpForm"
      >
        <div class="input">
          <mapfre-validation
            [input]="inputs[0]"
            [form]="phoneOtpForm"
          ></mapfre-validation>
        </div>
        <div class="row group-button text-center">
          <div class="col">
            <mapfre-button
              [additionalClasses]="'basic primary large-btn'"
              [disabledValue]="phoneOtpForm.valid"
              [inputType]="'submit'"
              [translateValue]="'CONTINUE' | translate"
            ></mapfre-button>
          </div>
        </div>        
      </form>
      <p class="mt-4 mb-2">
        {{ "DIDNT_RECEIVE_CODE" | translate }}
      </p>

      <div class="s-code mb-2" [ngClass]="{'dm-sans-medium': !isAcmic}" (click)="sendNewCode()">
        {{ "SEND_NEW_CODE_TO_MY_PHONE_SMALL_CASE" | translate }}
      </div>
      <p class="mb-0">
        {{ "OR_CONTACT_OUR_CUSTOMER_SERVICE" | translate }}
      </p>
      <p>
          <a href="tel:{{ 'CUSTOMER_SERVICE_NUMBER' | translate }}" class="mapfre link blue-link" [ngClass]="{ 'corporate-red dm-sans-medium font-weight-500': !isAcmic , 'underline': isAcmic}">
              {{ "CUSTOMER_SERVICE_NUMBER" | translate }}
          </a>
        </p>
    </div>
  </ng-template>
</div>
